import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Banner from './Banner';
import InsideContact from './InsideContact';


class CustomApplications extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div>
                <Banner
                    headText="Custom Applications"
                    subHeadText="Professionally crafted business applications customized to meet your specific needs"
                    subBoldText="INNOVATIVE. AFFORDABLE. PRACTICAL."
                    img="interior-1.jpg"
                />
                <div className="main-container">
                    <div className="container">
                        <div className="row">


                            <div className="col-lg-9 col-md-6 col-sm-12 margin5-0">
                                <h4>WHERE’S THE TECHNOLOGY SOLUTION THAT I NEED?</h4>
                                <p>
                                    Not every industry has an off-the-shelf technology solution. You know your business better than anyone else and exactly 
                                    what features you need to manage your business effectively. That's why we specialize in creating customized business 
                                    software applications and other technology based solutions. We remove the frustration and risk, and provide you the 
                                    professional development and deployment you need to take your business to the next level. We expertly do this on all
                                    platforms, and in all industries.<br /><br />

                                    By opting to build a custom online application, you’re not only saving money on infrastructure and data security, 
                                    but on scalability as well. Start small with controlled features and a few users, but very rapidly add functionality 
                                    and users without the need to migrate into a new platform or system. Most development cycles for our custom applications 
                                    are really short so you can scale the application with ease as your business grows.
                                </p>
                                <br />
                                <h4>I NEED A TECHNOLOGY SOLUTION THAT WORKS FOR ME</h4>
                                <p>
                                    Tired of running in technology circles? Technology solutions should work for you, not make your work harder.  
                                    Let us do for you what we do best. We can combine the latest state-of-the-art development tools with the most 
                                    powerful database technologies. We can extend the capabilities of your ERP investment while maintaining the 
                                    integrity of it's critical data. We can bridge gaps with other IT systems. We can also offer a full range of 
                                    other business services specifically tailored to help you grow and manage your business. Contact us to day and 
                                    learn how you can make things happen for business you thought beyond your reach. Surprisingly affordable. Amazingly functional.
                                </p>
                                <br />
                                <h4>GET A CUSTOM APP FOR YOUR BUSINESS TODAY!</h4>
                                <p>
                                    Customer Relationship Management (CRM) Platforms, Business Process Automation Systems, Customer Facing Web Sites & Portals, 
                                    E-Commerce / Online Store, Paperless Office Systems, Mobile Applications, and more...<br /><br />

                                    We'd like to hear about the challenges you face and discuss how we can help your business grow with one of our Custom Apps.
                                </p>
                            </div>




                            <InsideContact />

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(CustomApplications);


// WEBPACK FOOTER //
// ./src/components/CustomApplications.js